import { useState, useRef, useEffect } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { iminioBackend } from "../../api/iminio_provider";
import i18n from "../../plugins/i18n";

function CreateInterventionForm({ changeView, userGroup }) {
  let isMounted = false;
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [categories, setCategories] = useState([]);
  const [types, setTypes] = useState([]);
  const [condominia, setCondominia] = useState([]);
  const [users, setUsers] = useState([]);

  const [fieldType, setFieldType] = useState(null);
  const [fieldTypeOtherText, setFieldTypeOtherText] = useState("");
  const [fieldCategoria, setFieldCategoria] = useState(null);
  const [fieldCondominium, setFieldCondominium] = useState(null);
  const [fieldDate, setFieldDate] = useState("");
  const [fieldAssignedTo, setFieldAssignedTo] = useState(null);

  const fetchCategories = async () => {
    let response = await iminioBackend
      .list_intervention_categories({})
      .catch((e) => console.log(e));
    setCategories(response.categories);
  };

  const fetchTypes = async () => {
    let response = await iminioBackend
      .list_intervention_types({})
      .catch((e) => console.log(e));

    const reordered = [
      ...response.types.filter((item) => item.codename !== "other"),
      ...response.types.filter((item) => item.codename === "other"),
    ];

    setTypes(reordered);
  };

  const fetchCondominia = async () => {
    let response = await iminioBackend
      .list_all_condominia({})
      .catch((e) => console.log(e));
    setCondominia(response.condominia);
  };

  const fetchUsers = async () => {
    let response = await iminioBackend
      .list_user_options({})
      .catch((e) => console.log(e));
    setUsers(response.users);
  };

  useEffect(() => {
    const init = async () => {
      await fetchTypes();
      await fetchCategories();
      await fetchCondominia();
      await fetchUsers();
    };
    if (isMounted === false) {
      isMounted = true;
      init();
    }
  }, []);

  const parseDate = (date) => {
    date = date.toLocaleDateString("it-IT");
    console.log(date);
    if (!date) return null;
    const splitted = date.split("/");
    if (splitted.length < 3) return null;
    const yearIndex = splitted.findIndex((e) => e.length === 4);
    if (!yearIndex || yearIndex !== 2) return null;
    return `${splitted[2]}-${splitted[1]}-${splitted[0]}`;
  };

  const handleSubmit = async () => {
    setLoading(true);
    setError("");
    const parsedDate = parseDate(fieldDate);
    const today = new Date().toISOString().substring(0, 10);
    if (parsedDate < today) {
      setError(i18n.t("errors.past_dates"));
      setLoading(false);
      return;
    }
    if (parsedDate === null) {
      setError(
        i18n
          .t("errors.invalid_field")
          .replace(
            "{1}",
            i18n.t(`models.technical_intervention.fields.activity_at`)
          )
      );
      setLoading(false);
      return;
    }
    const newInterventionData = {
      type_id: parseInt(fieldType),
      category_id: parseInt(fieldCategoria),
      condominium_id: parseInt(fieldCondominium),
      assigned_to_id: userGroup === "admin" ? parseInt(fieldAssignedTo) : null,
      type_other_name: fieldTypeOtherText,
      activity_at: parsedDate,
    };
    await iminioBackend
      .create_technical_intervention(newInterventionData)
      .then((response) => {
        changeView("technical_intervention");
        setLoading(false);
      })
      .catch((e) => {
        switch (e.response?.data?.status?.code) {
          case "ERR_INVALID_FIELDS":
            let details = e.response.data.details[0];
            if (details.code === "string.empty")
              setError(
                i18n
                  .t("errors.required_field")
                  .replace(
                    "{1}",
                    i18n.t(
                      `models.technical_intervention.fields.${details.field}`
                    )
                  )
              );
            else if (
              ["number.base", "string.pattern.base", "date.base"].includes(
                details.code
              )
            )
              setError(
                i18n
                  .t("errors.invalid_field")
                  .replace(
                    "{1}",
                    i18n.t(
                      `models.technical_intervention.fields.${details.field}`
                    )
                  )
              );
            else setError(i18n.t("errors.unknown"));
            break;
          default:
            setError(i18n.t("errors.unknown"));
            break;
        }
        setLoading(false);
      });
  };

  return (
    <Col xs={12} className="mt-4">
      <Row>
        <Col xs={4} className="d-flex justify-content-start align-items-center">
          <i className="mdi mdi-file-document-plus text-20 fg-orange me-3"></i>
          <h3 className="">Creare Intervento</h3>
        </Col>
      </Row>
      <div className="divider-h mt-2"></div>
      <Row className="p-4">
        <Col xs={12} md={5} className="justify-content-center pe-4">
          <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
            <Form.Label column xs="3" className="text-9">
              Tipo (*)
            </Form.Label>
            <Col xs="9">
              <Form.Select
                onChange={(e) => setFieldType(e.target.value)}
                value={fieldType}
              >
                <option value="">Seleziona Tipo</option>
                {isLoading
                  ? ""
                  : types.map((e) => {
                      return (
                        <option key={`intervention-type-${e.id}`} value={e.id}>
                          {i18n.t(
                            `models.technical_intervention.types.${e.codename}`
                          )}
                        </option>
                      );
                    })}
              </Form.Select>
              {parseInt(fieldType) !== 10 ? (
                ""
              ) : (
                <Row className="mt-3">
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextEmail"
                  >
                    <Col xs="12">
                      <Form.Control
                        type="text"
                        onChange={(e) => setFieldTypeOtherText(e.target.value)}
                        placeholder="Nome del tipo di intervento alternativo"
                      />
                    </Col>
                  </Form.Group>
                </Row>
              )}
            </Col>
          </Form.Group>
        </Col>
        <Col xs={12} md={5} className="justify-content-center pe-4">
          <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
            <Form.Label column xs="4" className="text-9">
              Condominio (*)
            </Form.Label>
            <Col xs="8">
              <Form.Select
                onChange={(e) => setFieldCondominium(e.target.value)}
                value={fieldCondominium}
              >
                <option>Seleziona Condominio</option>
                {isLoading
                  ? ""
                  : condominia.map((e) => {
                      return (
                        <option key={`sel-condominium-${e.id}`} value={e.id}>
                          {e.name}
                        </option>
                      );
                    })}
              </Form.Select>
            </Col>
          </Form.Group>
        </Col>
        <Col xs={12} md={5} className="justify-content-center pe-4">
          <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
            <Form.Label column xs="5" className="text-9">
              Data Intervento (*)
            </Form.Label>
            <Col xs="7">
              <div className="d-flex flex-row">
                <i className="mdi mdi-calendar text-14 me-2"></i>
                <DatePicker
                  selected={fieldDate}
                  onChange={(date) => setFieldDate(date)}
                  disabled={isLoading}
                  dateFormat="dd/MM/yyyy"
                />
              </div>
            </Col>
          </Form.Group>
        </Col>
        <Col xs={12} md={5} className="justify-content-center pe-4">
          <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
            <Form.Label column xs="3" className="text-9">
              Categoria (*)
            </Form.Label>
            <Col xs="9">
              <Form.Select
                onChange={(e) => setFieldCategoria(e.target.value)}
                value={fieldCategoria}
              >
                <option>Seleziona Categoria</option>
                {isLoading
                  ? ""
                  : categories.map((e) => {
                      return (
                        <option key={`sel-category-${e.id}`} value={e.id}>
                          {i18n.t(
                            `models.technical_intervention.category.${e.codename}`
                          )}
                        </option>
                      );
                    })}
              </Form.Select>
            </Col>
          </Form.Group>
        </Col>
        <Col xs={12} md={5} className="justify-content-center pe-4 mb-2">
          {userGroup === "technician" ? (
            ""
          ) : (
            <Form.Group
              as={Row}
              className="mb-3"
              controlId="formPlaintextEmail"
            >
              <Form.Label column xs="3" className="text-9">
                Assegnato a
              </Form.Label>
              <Col xs="1"></Col>
              <Col xs="8">
                <Form.Select
                  onChange={(e) => setFieldAssignedTo(e.target.value)}
                  value={fieldAssignedTo}
                >
                  <option>Seleziona Utente</option>
                  {isLoading
                    ? ""
                    : users.map((e) => {
                        return (
                          <option key={`sel-user-${e.id}`} value={e.id}>
                            {e.first_name} {e.last_name}
                          </option>
                        );
                      })}
                </Form.Select>
              </Col>
            </Form.Group>
          )}
        </Col>
        <Col xs={12} className="d-flex justify-content-end">
          {!error || error.length === 0 ? (
            ""
          ) : (
            <div className="iminio-error-container bg-red fg-white justify-content-center px-4 text-9 iminio-border-round-force me-3">
              <i className="mdi mdi-alert-circle me-2"></i>
              {error}
            </div>
          )}
        </Col>
        <Col
          xs={12}
          className="d-flex justify-content-end align-items-center mt-3"
        >
          {!isLoading ? (
            ""
          ) : (
            <>
              <span className="me-2">Salvataggio in corso</span>
              <i className="mdi mdi-loading mdi-spin text-15 me-2"></i>
            </>
          )}
          <Button
            className={`px-5 corner-round bg-orange fg-white`}
            variant="orange"
            disabled={isLoading}
            onClick={() => {
              handleSubmit();
            }}
          >
            <i className="mdi mdi-content-save me-2"></i>
            Salva
          </Button>
        </Col>
      </Row>
    </Col>
  );
}

export default CreateInterventionForm;
